import Vue from "vue"
import moment from "moment"

const state = () => ({
  timeIntervalFunction: null,
  now: moment.utc(),
})

const mutations = {
  SET_TIME_INTERVAL_FUNCTION: (state, intervalFunction) => {
    Vue.set(state, "timeIntervalFunction", intervalFunction)
  },
  UPDATE_TIME: state => {
    Vue.set(state, "now", moment.utc())
  },
}

const actions = {
  startTimeUpdater ({ state, commit }) {
    if (state.timeIntervalFunction === null) {
      const intervalFunction = setInterval(() => {
        commit("UPDATE_TIME")
      }, 1000)
      commit("SET_TIME_INTERVAL_FUNCTION", intervalFunction)
    }
  },
  stopTimeUpdater ({ state, commit }) {
    if (state.timeIntervalFunction) {
      clearInterval(state.timeIntervalFunction)
      commit("SET_TIME_INTERVAL_FUNCTION", null)
    }
  },
}

const getters = {
  now: state => state.now,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/utils/time.js